import { EecsCancellationBeneficiaryType, EecsCancellationUsageCategory } from '../types/eecs-cancellations.types';

export const EecsCancellationBeneficiaryTypeMap = {
  [EecsCancellationBeneficiaryType.END_CONSUMER]: {
    name: 'END CONSUMER',
  },
  [EecsCancellationBeneficiaryType.ENERGY_SUPPLIER]: {
    name: 'ENERGY SUPPLIER',
  },
};

export const EecsCancellationUsageCategoryMap = {
  [EecsCancellationUsageCategory.DISCLOSURE]: {
    name: 'DISCLOSURE',
  },
  [EecsCancellationUsageCategory.SUPPORT]: {
    name: 'SUPPORT',
  },
  [EecsCancellationUsageCategory.OTHER]: {
    name: 'OTHER',
  },
};
